'use client';

import { Suspense } from 'react';
import { Footer } from '@/components/layout/footer';
import { NavigationProgress } from '@/components/layout/navigation/NavigationProgress';
import { TopHeader } from '@/components/layout/top-header';

interface CleanLayoutProps {
  children: React.ReactNode;
  showBack?: boolean;
  onboardingMode?: boolean;
}

export function CleanLayout({
  children,
  showBack: _showBack = true,
  onboardingMode = false,
}: CleanLayoutProps) {
  return (
    <div className="min-h-dvh flex flex-col">
      {/* Keeps the real usePathname (transition diffing); Suspense keeps the
          read out of the static shell. */}
      <Suspense>
        <NavigationProgress />
      </Suspense>
      <TopHeader
        hiddenSearch={true}
        hiddenGetStarted={true}
        classNameDivContainer="account-container"
        onboardingMode={onboardingMode}
      />

      <main className="flex-1 flex flex-col">
        <div className="flex-1">{children}</div>
        <Footer classNameDivContainer="account-container" />
      </main>
    </div>
  );
}
